import { render } from "./PlanetaryTrackRewards.vue?vue&type=template&id=0213cc04&ts=true"
import script from "./PlanetaryTrackRewards.vue?vue&type=script&lang=ts"
export * from "./PlanetaryTrackRewards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__